import firebase from "firebase";

// Initialize Firebase
var config = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: "sapworldannualday.firebaseapp.com",
  databaseURL: process.env.REACT_APP_databaseURL,
  projectId: "sapworldannualday",
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
};

firebase.initializeApp(config);
var messaging;
var analytics;
var db;

try {
  messaging = firebase.messaging();
  analytics = firebase.analytics();
  db = firebase.firestore();
} catch (error) {
  console.log("iphone does not support");
}

// messaging.onMessage(function (payload) {
//   try {
//     //try???
//     console.log("Message received. ", payload);
//     // alert("foreground");

//     const noteTitle = payload.notification.title;
//     const noteOptions = {
//       body: payload.notification.body,
//       icon: "typewriter.jpg", //this is my image in my public folder
//     };

//     console.log("title ", noteTitle, " ", payload.notification.body);
//     new Notification(noteTitle, noteOptions).onclick = function (event) {
//       // console.log(event);
//       // console.log(payload.notification.click_action);
//       if (
//         payload &&
//         payload.notification &&
//         payload.notification.click_action &&
//         payload.notification.click_action.length > 0
//       ) {
//         window.open(payload.notification.click_action, "_blank");
//       }
//       this.close();
//     };
//   } catch (error) {
//     console.log(error);
//   }
// });
// messaging.usePublicVapidKey(
//   "BJQ4TOUq-KqegiV12ZpOA9Y5cgysqeCr8iQSNY2oqG1MPGe-zF6JGmI3-c02M-2i-EzJNAaH2oacLkD2AL15gc8"
// );
export { messaging, db };
